// src/data/outlook2027.ts
//
// 2027년 정부예산안(2026년 9월 1일 발표) 기준 정부지원금 전망 데이터
// 출처: 기획재정부 2027년 예산안, 보건복지부 2027년 예산안,
//       국회 제출 예정 정부안 기준 (2026-09-02 확인)
//
// ※ 아래 내용은 '정부 예산안' 단계의 계획으로, 국회 심의 과정에서 변경될 수 있습니다.
//
import { OutlookItem } from '../types';

/** 2027년 예산안 전체 골격 */
export const budget2027 = {
    announcedAt: '2026-09-01',
    totalExpenditure: '820조 9,000억원',
    increase: '93조원 (전년 대비 12.8% 증가)',
    futureFund: '162조 3,000억원 (미래대응기금 신설)',
    youthBudget: '43조 3,000억원 (전년 28조 2,000억원 대비 53.5% 증가)',
    welfareBudget: '148조 7,697억원 (보건복지부, 전년 대비 8.2% 증가)',
    polarizationBudget: '117조 1,000억원 (양극화 대응, 전년 대비 36.6% 증가)',
    medianIncomeRaise: '기준 중위소득 6.7% 인상 (역대 최대)',
    note:
        '2027년 예산안은 국회 심의·의결을 거쳐 확정됩니다. 제도별 세부 시행 기준과 금액은 확정 예산과 시행령에 따라 달라질 수 있습니다.',
};

/** 2027년에 신설·확대되는 핵심 지원 제도 */
export const outlookItems: OutlookItem[] = [
    {
        id: 'honin-jiwongeum',
        category: 'parenting',
        title: '혼인지원금 신설',
        summary: '혼인신고를 한 부부에게 생애 1회 100만원을 지급합니다.',
        detail:
            '저출생 대응 3종 패키지의 첫 단계로, 혼인신고를 마친 부부에게 생애 한 번 100만원을 지원합니다. 2027년 하반기 혼인한 신혼부부부터 적용될 예정입니다. 기존 혼인세액공제와의 관계는 확정 예산과 시행령에서 정리됩니다.',
        figure: '100만원',
        figureLabel: '생애 1회',
        status: '신설',
    },
    {
        id: 'chulsan-jiwongeum-2027',
        category: 'parenting',
        title: '출산지원금 신설',
        summary: '첫째 1,000만원부터 지방 거주 시 최대 2,000만원까지 지급합니다.',
        detail:
            '기존의 첫만남이용권·부모급여 등 흩어져 있던 현금성 출산 지원을 하나로 통합하고 규모를 크게 늘립니다. 기본형은 첫째 1,000만원, 셋째 이상 1,500만원이며, 지방 거주 가구는 최대 2,000만원까지 받을 수 있도록 설계되었습니다.',
        figure: '최대 2,000만원',
        figureLabel: '출산 1회당',
        status: '신설',
    },
    {
        id: 'adong-gibon-sudang',
        category: 'parenting',
        title: '아동기본수당 신설',
        summary: '출산 이후 매월 20만~30만원을 지속 지급합니다.',
        detail:
            '기존 아동수당(월 10만원)과 부모급여를 흡수·확대하는 형태로, 출산 이후 매월 20만~30만원을 지급하는 아동기본수당이 신설됩니다. 미래대응기금에 편성되어 안정적인 재원 확보를 목표로 합니다.',
        figure: '월 20만~30만원',
        figureLabel: '아동 1명당',
        status: '통합',
    },
    {
        id: 'uriai-jarip-fund',
        category: 'parenting',
        title: '우리아이자립펀드 신설',
        summary: '출생부터 만 18세까지 연 최대 120만원을 적립해 최대 1억원을 만들어 줍니다.',
        detail:
            '2조 3,000억원 규모로 신설되는 자산형성 지원 사업입니다. 출생 시점부터 만 18세까지 연 최대 120만원을 정부가 적립해, 성년이 되는 시점에 최대 6,000만원~1억원을 수령할 수 있도록 설계되었습니다. 자녀 1명당 최대 7,500만원 규모의 혼인·출산·양육 패키지의 핵심 축입니다.',
        figure: '최대 1억원',
        figureLabel: '만 18세 만기 수령',
        status: '신설',
    },
    {
        id: 'cheongnyeon-cheotchwieop',
        category: 'worker',
        title: '청년첫취업지원제도 신설',
        summary: '청년 16만명에게 월 65만원의 구직촉진수당을 지급합니다.',
        detail:
            '첫 취업을 준비하는 청년 16만명을 대상으로 월 65만원의 구직촉진수당을 지급하는 제도가 신설됩니다. 고용보험 가입 이력이 없어 실업급여를 받을 수 없는 청년 구직자의 사각지대를 메우는 것이 목적입니다. 청년 일자리·창업 분야 예산은 5조 1,000억원 규모입니다.',
        figure: '월 65만원',
        figureLabel: '16만명 대상',
        status: '신설',
    },
    {
        id: 'cheongnyeon-mirae-jeokgeum',
        category: 'worker',
        title: '청년미래적금 대폭 확대',
        summary: '소득 요건을 없애고 정부 기여율을 최대 25%까지 높입니다.',
        detail:
            '청년도약계좌의 후속 자산형성 상품인 청년미래적금 예산이 7,000억원에서 1조 7,000억원으로 늘어납니다. 기존 연소득 7,500만원 이하였던 소득 요건이 폐지되어 모든 청년이 가입할 수 있게 되고, 정부 기여율은 일반형 6%, 우대형 15%로 상향됩니다. 비수도권 중소기업 근무자는 25%까지 우대받습니다.',
        figure: '기여율 최대 25%',
        figureLabel: '소득요건 폐지',
        status: '확대',
    },
    {
        id: 'cheongnyeon-jugeo-2027',
        category: 'housing',
        title: '청년 주거지원 18.5조원 투입',
        summary: '보편형 공공임대 2만호와 청년지원주택 1만호를 새로 공급합니다.',
        detail:
            '청년 주거 분야에 18조 5,000억원이 투입됩니다. 전용면적 50~84㎡ 규모의 보편형 공공임대주택 2만호가 새로 공급되고, 청년지원주택도 1만호가 추가됩니다. 특히 청년월세 지원의 소득 기준이 기준 중위소득 60% 이하에서 100% 이하로 완화되어 지원 대상이 크게 늘어납니다.',
        figure: '3만호',
        figureLabel: '공공임대 신규 공급',
        status: '확대',
    },
    {
        id: 'jibang-gukripdae-deungrokgeum',
        category: 'education',
        title: '지방 국립대 등록금 전액 장학금',
        summary: '2027년 신입생부터 지방 국립대 등록금을 전액 지원합니다.',
        detail:
            '2027학년도 신입생부터 지방 국립대학의 등록금을 전액 장학금으로 지원합니다. 수도권 집중 완화와 지역 인재 육성을 동시에 노리는 정책으로, 지방 대학 진학자의 학비 부담이 사실상 사라지게 됩니다.',
        figure: '등록금 전액',
        figureLabel: '2027년 신입생부터',
        status: '신설',
    },
    {
        id: 'munhwa-yesul-pass',
        category: 'education',
        title: '문화예술패스 확대',
        summary: '19~34세 청년에게 매년 10만~15만원의 문화비를 지원합니다.',
        detail:
            '만 19~34세 청년을 대상으로 공연·전시 관람에 사용할 수 있는 문화예술패스를 매년 10만~15만원 지급합니다. 기존 19세 대상 한시 사업에서 청년 전체로 대상이 확대됩니다.',
        figure: '연 10만~15만원',
        figureLabel: '19~34세 청년',
        status: '확대',
    },
    {
        id: 'gijun-jungwi-sodeuk-2027',
        category: 'welfare',
        title: '기준 중위소득 6.7% 인상',
        summary: '역대 최대 인상률로 기초생활보장 수급 대상이 확대됩니다.',
        detail:
            '2027년 기준 중위소득을 역대 최대 폭인 6.7% 인상합니다. 기준 중위소득은 생계·의료·주거·교육급여를 비롯해 70개가 넘는 복지사업의 선정 기준이 되므로, 인상 시 전 분야에서 수급 대상과 지급액이 함께 늘어납니다. 2026년 인상률은 6.51%였습니다.',
        figure: '+6.7%',
        figureLabel: '역대 최대 인상률',
        status: '확대',
    },
    {
        id: 'uiryo-geubyeo-buyang-pyeji',
        category: 'welfare',
        title: '의료급여 부양의무자 기준 폐지',
        summary: '자녀 소득 때문에 탈락하던 저소득 환자들이 새로 수급권을 얻습니다.',
        detail:
            '의료급여의 부양의무자 기준이 폐지됩니다. 그동안 본인은 소득이 없어도 자녀나 부모의 소득·재산 때문에 의료급여를 받지 못했던 저소득 노인과 환자들이 새롭게 수급 대상이 됩니다. 생계·주거·교육급여에 이어 의료급여까지 부양의무자 기준이 사라지는 것입니다.',
        figure: '부양의무자 기준 폐지',
        figureLabel: '수급권자 확대',
        status: '개편',
    },
    {
        id: 'gicho-yeongeum-2027',
        category: 'welfare',
        title: '기초연금 예산 25.7조원',
        summary: '예산이 11% 늘어나지만 소득 하위 70% 기준은 유지됩니다.',
        detail:
            '기초연금 예산이 23조 1,000억원에서 25조 7,000억원으로 2조 6,000억원(약 11%) 증가합니다. 다만 지급 대상을 소득 하위 70%로 유지하기로 하면서, 선별 지급 전환 등 구조 개혁은 다음 과제로 남게 되었습니다.',
        figure: '25조 7,000억원',
        figureLabel: '전년 대비 +11%',
        status: '확대',
    },
    {
        id: 'noin-iljari-118',
        category: 'welfare',
        title: '노인일자리 118만개로 확대',
        summary: '역대 최대 규모의 노인일자리가 공급됩니다.',
        detail:
            '노인일자리를 118만개로 확대해 역대 최대 규모로 공급합니다. 고령층 소득 보전과 사회 참여를 동시에 지원하는 정책으로, 공익활동형과 사회서비스형을 중심으로 늘어납니다.',
        figure: '118만개',
        figureLabel: '역대 최대 규모',
        status: '확대',
    },
    {
        id: 'ai-jikeop-hunryeon-2027',
        category: 'worker',
        title: '직업훈련·AI 훈련 대폭 확대',
        summary: '직업훈련 72만명, AI 특화 훈련 12만명으로 늘어납니다.',
        detail:
            '직업훈련 대상이 56만명에서 72만명으로 확대되고, K-뉴딜아카데미 등 AI 특화 훈련은 6만명에서 12만명으로 두 배 늘어납니다. 대학생 6만명에게 학점을 인정하는 인턴학기도 도입됩니다.',
        figure: '72만명',
        figureLabel: '직업훈련 대상',
        status: '확대',
    },
];

export const getOutlookByCategory = (category: string): OutlookItem[] =>
    category === 'all' ? outlookItems : outlookItems.filter(o => o.category === category);
